export default (params) => ({
  trigger: {
    name: 'content_blocks.stepped_propositions.view_content',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'view_content',
      params: {
        sub_feature: null,
        content: null,
      },
    },
    nonInt: true,
  },
});
